'use client';

import Image from "next/image";
import s from './AllModules.module.scss';
import Introduction from "../../home/introduction";
import Columns from "../../home/columns";
import Complex from "../../home/complex";
import Centered from "../../home/centered";
import Highlight from "../../home/highlight";
import Teams from "../teams";
import SuperMod from "../../home/super";

interface DataProps {
    data: any;
}

export default function ModulePrint({ data }: DataProps) {

    return (
        <>
            {data && data.map((item: any, index: any) => {
                if(index == 0) return null; // Skip the first item if it's not needed
                if(item._type == 'module.contentPage'){
                    return (
                        <section className={s.sectionIntroduction} key={`module-${index}-${item._type}`}>
                            <Introduction data={item} />
                        </section>
                    )
                } else if (item._type == 'module.super'){
                    return (
                        <section className={s.sectionSuper} key={`module-${index}-${item._type}`}>
                            <SuperMod data={item} />
                        </section>
                    )
                } else if(item._type == 'module.columns'){
                    return (
                        <section className={s.sectionColumns} key={`module-${index}-${item._type}`}>
                            <Columns data={item} />
                        </section>
                    )
                } else if (item._type == 'module.centered'){
                    return (
                        <section className={s.sectionCentered} key={`module-${index}-${item._type}`}>
                            <Centered data={item} />
                        </section>
                    )
                } else if (item._type == 'module.highlight'){
                    return (
                        <section className={s.sectionHighlight} key={`module-${index}-${item._type}`}>
                            <Highlight data={item} />
                        </section>
                    )
                } else if (item._type == 'module.complex'){
                    return (
                        <section className={s.sectionComplex} key={`module-${index}-${item._type}`}>
                            <Complex data={item} />
                        </section>
                    )
                } else if (item._type == 'module.teams'){
                    return (
                        <section className={s.sectionTeam} key={`module-${index}-${item._type}`}>
                            <Teams data={item} />
                        </section>
                    )
                }
            })}
        </>
    );
}